import { render, staticRenderFns } from "./qcmFrom.vue?vue&type=template&id=529e81bb&scoped=true"
import script from "./qcmFrom.vue?vue&type=script&lang=js"
export * from "./qcmFrom.vue?vue&type=script&lang=js"
import style0 from "./qcmFrom.vue?vue&type=style&index=0&id=529e81bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529e81bb",
  null
  
)

export default component.exports